module.exports = __webpack_public_path__ + "img/logo_wide.96055339.webp";